<div [ngClass]="progressMarginAndCursor()">
  <p class="step-name">{{ stepName() }}</p>
  <div class="progress-bar-bg" [ngClass]="progressRadius()">
    <div class="progress-bar-fill" [ngStyle]="progressStyle()" [ngClass]="progressColorAndRadius()"></div>
  </div>
</div>
